export default __webpack_public_path__ + "static/media/arrow_down.90613b82.svg";